export var DeliveryExpediencyEnum;
(function (DeliveryExpediencyEnum) {
    DeliveryExpediencyEnum["TWO_HR"] = "TWO_HR";
    DeliveryExpediencyEnum["FOUR_HR"] = "FOUR_HR";
    DeliveryExpediencyEnum["SAME_DAY"] = "SAME_DAY";
})(DeliveryExpediencyEnum || (DeliveryExpediencyEnum = {}));
